// Module
var code = "<select class=\"form-control input-sm\" name=\"{{vm.name}}\" ng-model=\"vm.model\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.onChange()\" ng-options=\"t.value as t.name | translate for t in vm.dataType\"> </select>";
// Exports
module.exports = code;